export default {
  methods: {
    cellTextEmpty () {return ''},
    cellIconCheckInverted (header, item, index) {return item[header.value] ? 'mdi-minus' : 'mdi-check'},
    cellIconCheck (header, item, index) {return item[header.value] ? 'mdi-check' : 'mdi-minus'},
    cellCheckClassInverted (header, item, index) {return item[header.value] ? 'grey--text lighten-1--text' : 'green--text'},
    cellCheckClass (header, item, index) {return item[header.value] ? 'green--text ft-cell' : 'grey--text lighten-1--text'},
    headerInvertedSwitch (label, field, sortable) {
      return {
        text: label,
        align: 'left',
        sortable: !!sortable,
        cellText: this.cellTextEmpty,
        cellIcon: this.cellIconCheckInverted,
        cellIconClass: this.cellCheckClassInverted,
        cellClass: 'ft-thin-cell',
        value: field
      }
    },
    headerSwitch (label, field, sortable) {
      return {
        text: label,
        align: 'left',
        sortable: !!sortable,
        cellText: this.cellTextEmpty,
        cellIcon: this.cellIconCheck,
        cellIconClass: this.cellCheckClass,
        cellClass: 'ft-thin-cell',
        value: field
      }
    },
    headerDragSort () {
      return {
        text: '',
        align: 'left',
        sortable: false,
        value: null
      }
    },
    headerText (label, field, sortable, cellText) {
      return {
        text: label,
        align: 'left',
        sortable: !!sortable,
        value: field,
        cellText: cellText
      }
    },
    headerDateTime (label, field, sortable, dateFormat, timeFormat) {
      return {
        text: label,
        align: 'left',
        sortable: !!sortable,
        value: field,
        dateFormat: dateFormat || 'YYYY-MM-DD',
        timeFormat: timeFormat || 'hh:mm A'
      }
    },
    headerDate (label, field, sortable, dateFormat) {
      return {
        text: label,
        align: 'left',
        sortable: !!sortable,
        value: field,
        dateFormat: dateFormat || 'YYYY-MM-DD'
      }
    },
    headerTime (label, field, sortable, timeFormat) {
      return {
        text: label,
        align: 'left',
        sortable: !!sortable,
        value: field,
        timeFormat: timeFormat || 'hh:mm A'
      }
    },
    headerSlot (label, field, sortable, cellClass) {
      return {
        text: label,
        align: 'left',
        sortable: !!sortable,
        value: field,
        cellClass: cellClass,
        slot: true
      }
    },
    headerEditor (options) {
      options = options || {}
      options.editor = options.editor || {}
      var editor = options.editor
      editor.type = editor.type || 'text'
      editor.inputType = editor.inputType || ''
      editor.label = editor.label || options.label || ''
      editor.placeholder = editor.placeholder || editor.label
      editor.prefix = editor.prefix || ''
      return {
        sortable: false,
        text: options.label,
        align: options.align || 'left',
        value: options.field,
        editor: editor,
        thin: options.thin,
        small: options.small
      }
    }
  }
}
